var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("base-form", {
    ref: "baseFormRef",
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function ({ invalid }) {
          return [
            _c(
              "base-dialog",
              {
                attrs: {
                  "content-class": "foex-dialog",
                  name: _vm.name,
                  "max-width": "1200px",
                  scrollable: true,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "header",
                      fn: function () {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(_vm.terminalBlockId ? "Edit" : "Add") +
                              " Terminal Block " +
                              _vm._s(
                                _vm.terminalBlockId
                                  ? `(ID: ${_vm.terminalBlockId})`
                                  : ""
                              ) +
                              " "
                          ),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "dialogFooter",
                      fn: function () {
                        return [
                          _c(
                            "div",
                            { staticClass: "d-flex justify-end" },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "mr-2",
                                  attrs: { color: "grey", text: "" },
                                  on: { click: _vm.closeDialog },
                                },
                                [_vm._v("Cancel")]
                              ),
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    disabled: invalid,
                                    color: "primary",
                                  },
                                  on: { click: _vm.save },
                                },
                                [_vm._v("Save")]
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  true
                ),
              },
              [
                _c(
                  "div",
                  [
                    _c(
                      "v-row",
                      [
                        _c(
                          "v-col",
                          { attrs: { cols: "6" } },
                          [
                            _c("base-text-field", {
                              attrs: {
                                label: "Manufacturer",
                                rules: "required",
                                value: _vm.terminalBlockForm.manufacturer,
                                name: "manufacturer",
                              },
                              on: {
                                "update:value": function ($event) {
                                  return _vm.$set(
                                    _vm.terminalBlockForm,
                                    "manufacturer",
                                    $event
                                  )
                                },
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          { attrs: { cols: "6" } },
                          [
                            _c("base-text-field", {
                              attrs: {
                                label: "Model Number",
                                rules: "required",
                                value: _vm.terminalBlockForm.modelNumber,
                                name: "modelNumber",
                              },
                              on: {
                                "update:value": function ($event) {
                                  return _vm.$set(
                                    _vm.terminalBlockForm,
                                    "modelNumber",
                                    $event
                                  )
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "v-row",
                      [
                        _c(
                          "v-col",
                          { attrs: { cols: "6" } },
                          [
                            _c("base-text-field", {
                              attrs: {
                                label: "Serial Number",
                                rules: "required",
                                value: _vm.terminalBlockForm.serialNumber,
                                name: "serialNumber",
                              },
                              on: {
                                "update:value": function ($event) {
                                  return _vm.$set(
                                    _vm.terminalBlockForm,
                                    "serialNumber",
                                    $event
                                  )
                                },
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          { attrs: { cols: "6" } },
                          [
                            _c("base-text-field", {
                              attrs: {
                                label: "Ex Marking",
                                rules: "required",
                                value: _vm.terminalBlockForm.exMarking,
                                name: "exMarking",
                              },
                              on: {
                                "update:value": function ($event) {
                                  return _vm.$set(
                                    _vm.terminalBlockForm,
                                    "exMarking",
                                    $event
                                  )
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "v-row",
                      [
                        _c(
                          "v-col",
                          { attrs: { cols: "6" } },
                          [
                            _c("base-text-field", {
                              attrs: {
                                label: "Certification Number",
                                rules: "required",
                                value:
                                  _vm.terminalBlockForm.certificationNumber,
                                name: "certificationNumber",
                              },
                              on: {
                                "update:value": function ($event) {
                                  return _vm.$set(
                                    _vm.terminalBlockForm,
                                    "certificationNumber",
                                    $event
                                  )
                                },
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          { attrs: { cols: "6" } },
                          [
                            _c("base-text-field", {
                              attrs: {
                                label: "The rated maximum dissipated power (W)",
                                type: "number",
                                value:
                                  _vm.terminalBlockForm
                                    .ratedMaximumDissipatedPower,
                                name: "ratedMaximumDissipatedPower",
                              },
                              on: {
                                "update:value": function ($event) {
                                  return _vm.$set(
                                    _vm.terminalBlockForm,
                                    "ratedMaximumDissipatedPower",
                                    $event
                                  )
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c("v-divider", { staticClass: "my-4" }),
                    _c(
                      "v-row",
                      [
                        _c("v-col", { attrs: { cols: "12" } }, [
                          _c("h4", { staticClass: "mb-3" }, [
                            _vm._v("Current vs Cross Section Table"),
                          ]),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "v-row",
                      [
                        _c("v-col", { attrs: { cols: "6" } }, [
                          _c(
                            "div",
                            { staticClass: "d-flex align-center mb-2" },
                            [
                              _c("base-text-field", {
                                staticClass: "mr-2",
                                attrs: {
                                  label: "Add Current (A) Row",
                                  value: _vm.newCurrentValue,
                                  name: "newCurrentValue",
                                  density: "compact",
                                },
                                on: {
                                  "update:value": function ($event) {
                                    _vm.newCurrentValue = $event
                                  },
                                },
                              }),
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    color: "primary",
                                    small: "",
                                    disabled: !_vm.newCurrentValue.trim(),
                                  },
                                  on: { click: _vm.addCurrentRow },
                                },
                                [
                                  _c("v-icon", { attrs: { small: "" } }, [
                                    _vm._v("mdi-plus"),
                                  ]),
                                  _vm._v(" Add Row "),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]),
                        _c("v-col", { attrs: { cols: "6" } }, [
                          _c(
                            "div",
                            { staticClass: "d-flex align-center mb-2" },
                            [
                              _c("base-text-field", {
                                staticClass: "mr-2",
                                attrs: {
                                  label: "Add Cross Section (mm²) Column",
                                  value: _vm.newCrossSectionValue,
                                  name: "newCrossSectionValue",
                                  density: "compact",
                                },
                                on: {
                                  "update:value": function ($event) {
                                    _vm.newCrossSectionValue = $event
                                  },
                                },
                              }),
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    color: "primary",
                                    small: "",
                                    disabled: !_vm.newCrossSectionValue.trim(),
                                  },
                                  on: { click: _vm.addCrossSectionColumn },
                                },
                                [
                                  _c("v-icon", { attrs: { small: "" } }, [
                                    _vm._v("mdi-plus"),
                                  ]),
                                  _vm._v(" Add Column "),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "v-row",
                      [
                        _c(
                          "v-col",
                          { attrs: { cols: "12" } },
                          [
                            _c(
                              "v-card",
                              { staticClass: "elevation-1" },
                              [
                                _c("v-card-text", { staticClass: "pa-0" }, [
                                  _c(
                                    "div",
                                    { staticClass: "table-scroll-container" },
                                    [
                                      _c(
                                        "table",
                                        { staticClass: "foex-table" },
                                        [
                                          _c("thead", [
                                            _c("tr", [
                                              _c(
                                                "th",
                                                {
                                                  staticClass: "current-header",
                                                  attrs: { rowspan: "2" },
                                                },
                                                [_vm._v("Current (A)")]
                                              ),
                                              _c(
                                                "th",
                                                {
                                                  staticClass:
                                                    "cross-section-main-header",
                                                  attrs: {
                                                    colspan:
                                                      _vm.dynamicTable
                                                        .crossSectionValues
                                                        .length,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " Cross Section (mm²) "
                                                  ),
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      staticClass: "ml-2",
                                                      attrs: {
                                                        icon: "",
                                                        "x-small": "",
                                                        color: "primary",
                                                      },
                                                      on: {
                                                        click:
                                                          _vm.addCrossSectionColumn,
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: {
                                                            "x-small": "",
                                                          },
                                                        },
                                                        [_vm._v("mdi-plus")]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]),
                                            _c(
                                              "tr",
                                              _vm._l(
                                                _vm.dynamicTable
                                                  .crossSectionValues,
                                                function (crossSection, index) {
                                                  return _c(
                                                    "th",
                                                    {
                                                      key: `cross-header-${index}`,
                                                      staticClass:
                                                        "cross-section-value-header",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "d-flex align-center justify-center",
                                                        },
                                                        [
                                                          _c("v-text-field", {
                                                            staticClass:
                                                              "cross-section-input",
                                                            attrs: {
                                                              value:
                                                                crossSection.value,
                                                              dense: "",
                                                              "hide-details":
                                                                "",
                                                            },
                                                            on: {
                                                              input: function (
                                                                $event
                                                              ) {
                                                                return _vm.updateCrossSectionValue(
                                                                  index,
                                                                  $event
                                                                )
                                                              },
                                                            },
                                                          }),
                                                          _c(
                                                            "v-btn",
                                                            {
                                                              staticClass:
                                                                "ml-1",
                                                              attrs: {
                                                                icon: "",
                                                                "x-small": "",
                                                                color: "error",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.removeCrossSectionColumn(
                                                                      index
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "v-icon",
                                                                {
                                                                  attrs: {
                                                                    "x-small":
                                                                      "",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "mdi-close"
                                                                  ),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                          ]),
                                          _c(
                                            "tbody",
                                            [
                                              _vm._l(
                                                _vm.dynamicTable.currentValues,
                                                function (current, rowIndex) {
                                                  return _c(
                                                    "tr",
                                                    {
                                                      key: `current-row-${rowIndex}`,
                                                    },
                                                    [
                                                      _c(
                                                        "td",
                                                        {
                                                          staticClass:
                                                            "current-value-cell",
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "d-flex align-center",
                                                            },
                                                            [
                                                              _c(
                                                                "v-text-field",
                                                                {
                                                                  staticClass:
                                                                    "current-input",
                                                                  attrs: {
                                                                    value:
                                                                      current.value,
                                                                    dense: "",
                                                                    "hide-details":
                                                                      "",
                                                                  },
                                                                  on: {
                                                                    input:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.updateCurrentValue(
                                                                          rowIndex,
                                                                          $event
                                                                        )
                                                                      },
                                                                  },
                                                                }
                                                              ),
                                                              _c(
                                                                "v-btn",
                                                                {
                                                                  staticClass:
                                                                    "ml-1",
                                                                  attrs: {
                                                                    icon: "",
                                                                    "x-small":
                                                                      "",
                                                                    color:
                                                                      "error",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.removeCurrentRow(
                                                                          rowIndex
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-icon",
                                                                    {
                                                                      attrs: {
                                                                        "x-small":
                                                                          "",
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "mdi-close"
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._l(
                                                        _vm.dynamicTable
                                                          .crossSectionValues,
                                                        function (
                                                          crossSection,
                                                          colIndex
                                                        ) {
                                                          return _c(
                                                            "td",
                                                            {
                                                              key: `data-${rowIndex}-${colIndex}`,
                                                              staticClass:
                                                                "data-cell",
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "d-flex align-center justify-center",
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-text-field",
                                                                    {
                                                                      staticClass:
                                                                        "data-input",
                                                                      attrs: {
                                                                        dense:
                                                                          "",
                                                                        "hide-details":
                                                                          "",
                                                                      },
                                                                      on: {
                                                                        input:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.updateTableCell(
                                                                              rowIndex,
                                                                              `cross_${colIndex}`,
                                                                              $event
                                                                            )
                                                                          },
                                                                      },
                                                                      model: {
                                                                        value:
                                                                          _vm
                                                                            .dynamicTable
                                                                            .tableData[
                                                                            rowIndex
                                                                          ][
                                                                            `cross_${colIndex}`
                                                                          ],
                                                                        callback:
                                                                          function (
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm
                                                                                .dynamicTable
                                                                                .tableData[
                                                                                rowIndex
                                                                              ],
                                                                              `cross_${colIndex}`,
                                                                              $$v
                                                                            )
                                                                          },
                                                                        expression:
                                                                          "dynamicTable.tableData[rowIndex][`cross_${colIndex}`]",
                                                                      },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                    ],
                                                    2
                                                  )
                                                }
                                              ),
                                              _vm.dynamicTable.currentValues
                                                .length === 0
                                                ? _c("tr", [
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-center pa-4",
                                                        attrs: {
                                                          colspan:
                                                            _vm.dynamicTable
                                                              .crossSectionValues
                                                              .length + 1,
                                                        },
                                                      },
                                                      [
                                                        _c("p", [
                                                          _vm._v(
                                                            "No current values added. Use the controls above to add rows and columns."
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                  ])
                                                : _vm._e(),
                                            ],
                                            2
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }